// extracted by mini-css-extract-plugin
export default {"stickyArticleHeader":"n_bj","stickyArticleHeaderContainer":"n_bk","stickyArticleHeaderButton":"n_bl","text_left":"n_bm","progressContainer":"n_bn","progressBar":"n_bp"};